import React, { useState, useEffect, createContext, useContext } from "react";
import { useSelector, shallowEqual } from "react-redux";
import {
  useGetDocumentsQuery,
  useGetDocumentsCategoriesQuery,
  useGetUsersByPracticeQuery,
  documentApi,
  useDeleteDocumentMutation,
  useGetProvidersQuery,
} from "../../services/documentService";
import { DocumentTable } from "./document-table/documentTable";
import { DocumentForm } from "./document-form/documentForm";
import { toast } from "react-toastify";
// import { AddDocuments } from "./add-documents/AddDocuments";
// import { EditDocument } from "./edit-document/editDocuments";
import { cloneDeep } from "lodash";
import { useForm } from "react-hook-form";
// import AddTaskDialog from "../Triage-Module/AddTaskDialog";
// import { useGetTriageMetaQuery } from "app/redux/triageServices";
import baseApiHelper from "../../services/baseApiHelper";
import MainPageDialog from "../../components/dialog";
import ActionDialog from "../../components/actionDialog";
import { Loader } from "../../components/loader";
import ConvertStringToHtml from "../../components/ConvertStringToHtml";
import { PdfViewer } from "../../components/pdfViewer";
import Share from "../../components/ShareEmaileFax/Share";
import { SearchComponent } from "../../components/reactHookFormFields/searchComponentField";

const DocumentContext = createContext({});

export function useDocumentContext() {
  return useContext(DocumentContext);
}

export const Documents = ({
  selectedFiles,
  setSelectedFiles,
  showHeaderBtn,
  uploadedList,
  setCheckLength,
  selectedChat,
  // setShowAddDocumentsForm,
  // showAddDocumentsForm,
}) => {
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isNotePopupOpen, setIsNotePopupOpen] = useState(false);
  const [itemToAddToNote, setItemToAddToNote] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [selectedCat, setSelectedCat] = useState(null);
  const [shareDialog, setShareDialog] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState([]);
  const [fetchProviders] = documentApi.endpoints.getProviders.useLazyQuery();
  const [deleteDocument] = useDeleteDocumentMutation();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showLoader, setShowLoader] = useState(false);

  const [showEditDocumentForm, setShowEditDocumentForm] = useState(false);
  const [documentEditValues, setDocumentEditValues] = useState(null);
  const [pdfViewer, setPdfViewer] = useState({ isOpen: false, uuid: "" });
  const [showViewDocument, setShowViewDocument] = useState(false);
  const [documentViewValues, setDocumentViewValues] = useState(null);
  const [documentSlectedData, setDocumentSlectedData] = useState();
  const [addToTaskDilaogState, setAddToTaskDilaogState] = useState(false);

  const { data: documentCategories } = useGetDocumentsCategoriesQuery({
    pid: selectedChat?.pid,
    status: "all",
    title: "",
    flat: 1,
  });

  // const { data: allMetaData } = useGetTriageMetaQuery({
  //   pid: selectedNote?.pid,
  // });

  const [params, setParams] = useState({
    text: "",
    category: null,
    provider_ids: [],
  });

  const {
    data: documentsData,
    isLoading,
    isFetching,
    refetch,
  } = useGetDocumentsQuery({
    pid: selectedChat?.pid,
    text: params["text"],
    category: params["category"],
    provider_ids: params["provider_ids"],
    flat_docs: true,
    by_date_order: "desc",
  });

  const { control, getValues, setValue, watch, reset } = useForm({
    defaultValues: {},
  });

  watch(); // don't remove it. Watching form changes
  const isAnyDocumentSelected = () => {
    return documentsData?.some((doc) => {
      return getValues(`doc_${doc.id}`);
    });
  };

  const openDocument = (item) => {
    if (item.uuid) {
      setPdfViewer({ isOpen: true, uuid: item.uuid });
    }
    setDocumentSlectedData(item);
  };

  useEffect(() => {
    if (documentsData?.length && showHeaderBtn) {
      let attachedDocuments = [];
      attachedDocuments = cloneDeep(selectedNote?.clinical_data?.documents);
      resetCheckBoxes(attachedDocuments);
    }
    if (setCheckLength) {
      setCheckLength(documentsData?.length);
    }
  }, [documentsData]);
  useEffect(() => {
    if (documentsData?.length > 0) {
      if (selectedFiles?.length > 0) {
        selectedFiles?.map((document) => {
          setValue(`doc_${document.id}`, true);
        });
      }
    }
  }, [selectedFiles, documentsData]);
  const resetCheckBoxes = (attachedDocuments) => {
    if (attachedDocuments) {
      attachedDocuments = attachedDocuments?.split(",");
      let attachedDocumentCount = 0;
      documentsData.forEach((doc) => {
        const foundDocument = attachedDocuments?.find((item) => item == doc.id);
        if (foundDocument) {
          if (selectedFiles?.length == 0) {
            setValue(`doc_${document.id}`, false);
          } else {
            setValue(`doc_${doc.id}`, true);
            attachedDocumentCount++;
          }
        } else {
          setValue(`doc_${doc.id}`, false);
        }
      });

      if (attachedDocumentCount >= documentsData.length) {
        setValue("select_all", true);
      }
    } else {
      reset();
    }
  };

  const selectUnselectAll = (evt) => {
    if (evt?.target?.checked) {
      documentsData?.map((document) => {
        setValue(`doc_${document.id}`, true);
      });
      setSelectedFiles(documentsData);
    } else {
      documentsData?.map((document) => {
        setValue(`doc_${document.id}`, false);
      });
      setSelectedFiles([]);
    }
  };
  const onChangeSelection = (evt) => {
    if (evt.target.checked) {
      let selectionCount = 0;
      documentsData?.map((template) => {
        if (getValues(template.id)) {
          selectionCount++;
        }
      });

      if (selectionCount == documentsData.length) {
        setValue("select_all", true);
      }
    } else {
      setValue("select_all", false);
    }
  };

  const { data: providerList } = useGetProvidersQuery({ keyword: "" });

  const searchHandler = () => {
    setParams({
      text: searchKey,
      category: selectedCat?.id || null,
      provider_ids: selectedProvider?.length
        ? selectedProvider
            .map((item) => {
              return item.id;
            })
            .join(",")
        : "",
    });
  };

  const resetHandler = () => {
    setParams({
      text: "",
      category: null,
      provider_ids: [],
    });

    setSearchKey("");
    setSelectedCat(null);
    setSelectedProvider([]);
  };

  const customStyles = {
    border: "2px solid black",

    groupHeading: (provided, state) => ({
      ...provided,
      borderBottom: "1px dotted pink",
      color: "#74ABB1",
      padding: 10,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  const CustomOption = (props) => {
    const { innerProps, value, name } = props;
    return (
      <div
        {...innerProps}
        className="grid grid-cols-12 gap-3 w-full px-3 py-2 cursor-pointer hover:bg-blue-200"
      >
        <p className="col-span-10">{value.name}</p>
      </div>
    );
  };

  const searchCat = async (query) => {
    return new Promise((res) => {
      if (query) {
        res(
          documentCategories.filter((item) => {
            return item?.name?.toLowerCase().includes(query.toLowerCase());
          })
        );
      } else {
        res(documentCategories);
      }
    });
  };

  const searchProvider = async (query) => {
    const response = await fetchProviders({ keyword: query });

    return new Promise((res) => {
      res(response.data);
    });
  };

  const deleteDoc = (document) => {
    setIsDeletePopupOpen(true);
    setItemToDelete(document.id);
  };
  const shareDoc = () => {
    setShareDialog(true);
  };
  const editHandler = (values) => {
    setShowEditDocumentForm(true);
    setDocumentEditValues(values);
  };
  const invalidateDocuMateDocumentsList = () => {
    setTimeout(() => {
      baseApiHelper().invalidateTags(["DocumateDocumentsList"]);
    }, 3000);
  };

  const delHandler = () => {
    setShowLoader(true);
    deleteDocument({ id: itemToDelete })
      .then((response) => {
        if (response?.data?.code == 0) {
          refetch({
            pid: selectedPatient?.Patient?.id,
            flat_docs: true,
            by_date_order: "desc",
          });
          resetHandler();
          toast.success(<ConvertStringToHtml msg={response?.data?.msg} />);
          resetHandler();
          setIsDeletePopupOpen(false);
          invalidateDocuMateDocumentsList();
        } else {
          toast.error(<ConvertStringToHtml msg={response?.data?.msg} />);
        }
      })
      .catch((err) => {
        toast.error(<ConvertStringToHtml msg={"Document deletion failed."} />);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  // const [linkComponentDataWithNote] = useLinkComponentDataWithNoteMutation();

  // const linkResultWithNote = (document, isRemoveFromNote, isAllSelected) => {
  //   let activeData = [];
  //   if (selectedNote?.clinical_data?.documents) {
  //     activeData = cloneDeep(selectedNote?.clinical_data?.documents);
  //     activeData = activeData.split(",");
  //   }

  //   if (isAllSelected) {
  //     if (isRemoveFromNote) {
  //       documentsData.forEach((element) => {
  //         if (getValues(`doc_${element?.id}`)) {
  //           const foundDocumentIndex = activeData.indexOf(element?.id);
  //           if (foundDocumentIndex > -1) {
  //             activeData.splice(foundDocumentIndex, 1);
  //           }
  //         }
  //       });
  //     } else {
  //       documentsData.forEach((element) => {
  //         if (getValues(`doc_${element?.id}`)) {
  //           const foundDocumentIndex = activeData.indexOf(element?.id);
  //           if (foundDocumentIndex == -1) {
  //             activeData.push(element?.id);
  //           }
  //         }
  //       });
  //     }
  //   } else {
  //     if (isRemoveFromNote) {
  //       const foundDocumentIndex = activeData.indexOf(document?.id);
  //       if (foundDocumentIndex > -1) {
  //         activeData.splice(foundDocumentIndex, 1);
  //       }
  //     } else {
  //       activeData.push(document?.id);
  //     }
  //   }

  //   activeData = activeData.join(",");

  //   let data = {
  //     active: activeData,
  //     extracted: [],
  //     slug: "documents",
  //     note: { ...selectedNote },
  //   };

  //   linkComponentDataWithNote(data).then((res) => {
  //     if (res?.data?.response?.code == 0) {
  //       toast.success(res?.data?.response?.msg);
  //       baseApiHelper().invalidateTags(["Document"]);
  //       let clinicalData = cloneDeep(selectedNote?.clinical_data);
  //       if (!clinicalData) {
  //         clinicalData = {};
  //       }
  //       clinicalData.documents = activeData;
  //       baseApiHelper().updateNoteSliceField("clinical_data", clinicalData);
  //       resetCheckBoxes(activeData);
  //       invalidateDocuMateDocumentsList();
  //     } else if (res?.data?.response?.msg) {
  //       toast.error(res?.data?.response?.msg);
  //     }
  //   });
  // };
  return (
    <DocumentContext.Provider
      value={{
        shareDoc,
        deleteDoc,
        editHandler,
        // linkResultWithNote,
        isAnyDocumentSelected,
        selectUnselectAll,
        onChangeSelection,
        control,
        openDocument,
      }}
    >
      <div className="p-2">
        {/* {showAddDocumentsForm && (
          <AddDocuments
            setShowAddDocumentsForm={setShowAddDocumentsForm}
            setShowLoader={setShowLoader}
            refetchDocumentsList={() => {
              refetch({
                pid: selectedPatient?.Patient?.id,
                flat_docs: true,
                by_date_order: "desc",
              });
              resetHandler();
              invalidateDocuMateDocumentsList();
            }}
          />
        )} */}

        {/* {showEditDocumentForm && (
          <EditDocument
            documentDetails={documentEditValues}
            setShowEditDocumentForm={setShowEditDocumentForm}
            setShowLoader={setShowLoader}
            refetchDocumentsList={() => {
              refetch({
                pid: selectedPatient?.Patient?.id,
                flat_docs: true,
                by_date_order: "desc",
              });
              resetHandler();
              invalidateDocuMateDocumentsList();
            }}
          />
        )} */}
        {(isFetching || showLoader) && (
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[9999]">
            {" "}
            <Loader />
          </div>
        )}
        <div
          className={`flex gap-2 justify-between items-start ${
            showEditDocumentForm && "hidden"
          }`}
        >
          <div className="flex gap-2 items-start">
            <input
              type="text"
              className="p-2.5  placeholder:text-black-c-50 placeholder:font-normal placeholder:text-base w-full border border-gray-300 rounded h-10"
              placeholder="Search By Keyword"
              onChange={(e) => {
                setSearchKey(e.target.value);
              }}
              value={searchKey}
            />
            <SearchComponent
              error={false}
              placeholder="Select Provider"
              components={{ Option: CustomOption }}
              defaultOptions={providerList || []}
              styles={customStyles}
              className="w-56"
              onSelection={(item) => {
                setSelectedProvider(item);
              }}
              loadData={(query) => searchProvider(query)}
              hideSelectedOptions={false}
              checkLength={false}
              noOptionsMessage={"no record found"}
              labeShow="name"
              key={`provider_select_${selectedProvider?.length !== 0 ? 1 : 2}`}
              isMulti={true}
              defaultSelectedValue={selectedProvider}
            />
            <SearchComponent
              error={false}
              placeholder="Document Type"
              components={{ Option: CustomOption }}
              defaultOptions={documentCategories || []}
              styles={customStyles}
              className="w-56"
              onSelection={(item) => {
                setSelectedCat(item);
              }}
              defaultSelectedValue={selectedCat}
              loadData={(query) => searchCat(query)}
              hideSelectedOptions={false}
              checkLength={false}
              noOptionsMessage={"no record found"}
              labeShow="name"
              key={selectedCat !== null ? 1 : 2}
            />

            <button
              onClick={() => {
                searchHandler();
              }}
              type="button"
              class="py-1 px-2 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover h-10"
            >
              Search
            </button>
            <button
              onClick={() => {
                resetHandler();
              }}
              type="button"
              class="py-1 px-2 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover h-10"
            >
              Reset
            </button>
          </div>
          {/* <div className="flex gap-2">
            <button
              onClick={() => {
                setShowAddDocumentsForm(true);
              }}
              type="button"
              class="py-1 px-2 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover h-10"
            >
              Upload
            </button>
          </div> */}
        </div>
        <div className="mt-4 text-left">
          <DocumentTable
            selectedChat={selectedChat}
            uploadedList={uploadedList}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            docData={documentsData}
            showHeaderBtn={showHeaderBtn}
          />

          <ActionDialog
            headerTitle="Delete Document"
            onCancelHandler={() => {
              setIsDeletePopupOpen(false);
            }}
            setShowModal={() => {
              setIsDeletePopupOpen(false);
            }}
            showModal={isDeletePopupOpen}
            onConfirmHandler={delHandler}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Delete"}
            title="Are you sure you want to delete document?"
          />
          {shareDialog && (
            <Share
              from={"shareNote"}
              bulk={true}
              sharePreviewUrl={"messages/read_attachment?uuid"}
              printData={"printData"}
              setShowShareeFax={setShareDialog}
              userUniqueId={selectedFiles}
            />
          )}
        </div>

        {pdfViewer.isOpen && (
          <MainPageDialog
            footer={false}
            title={"View Document"}
            component={
              <PdfViewer
                document={documentSlectedData}
                uuid={pdfViewer.uuid}
                closeHandler={() => setPdfViewer({})}
                addToTaskDilaogState={addToTaskDilaogState}
                setAddToTaskDilaogState={setAddToTaskDilaogState}
              />
            }
            onCancelHandler={() => setPdfViewer({})}
          />
        )}

        {/* {addToTaskDilaogState && (
          <AddTaskDialog
            selectedTask={""}
            metaData={allMetaData}
            singleShedule={""}
            addToTaskDilaogState={addToTaskDilaogState}
            setAddToTaskDilaogState={setAddToTaskDilaogState}
            document={documentSlectedData}
          />
        )} */}
      </div>
    </DocumentContext.Provider>
  );
};
